<template>
  <v-card class="rounded-sm" color="primary">
    <v-card-text>
      <v-form v-model="referenciaForm" ref="form">
        <v-container>
          <v-row>
            <v-col cols="12">
              <BaseInput class="mb-1" v-model="referencia.nombre" :rules="nameRules" validate-on-blur>
                <template v-slot:label>Nombre completo <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <v-col cols="6">
              <BaseInput v-model="maskedPhone" v-mask="'###-###-##-##'" maxlength="13" :rules="nameRules">
                <template v-slot:label>Teléfono <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <v-col cols="6">
              <BaseInput
                v-model.number="referencia.tiempoConocerse"
                type="number"
                :rules="nameRules"
                min="0"
                validate-on-blur
              >
                <template v-slot:label>Tiempo de ser vecinos (años) <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <div class="col-12">
              <h3>Domicilio</h3>
            </div>
            <v-col cols="6">
              <BaseSelect class="mb-1" v-model="selectedEstado" :items="estados">
                <template v-slot:label>Estado <span class="red--text">*</span> </template>
              </BaseSelect>
            </v-col>
            <v-col cols="6">
              <BaseSelect class="mb-1" v-model="referencia.fk_idmunicipio" :items="municipiosOptions">
                <template v-slot:label>Municipio <span class="red--text">*</span> </template>
              </BaseSelect>
            </v-col>
            <v-col cols="4">
              <BaseInput v-model="referencia.cp" :rules="nameRules" validate-on-blur>
                <template v-slot:label>Código Postal <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <v-col cols="8">
              <BaseInput v-model="referencia.colonia" :rules="nameRules" validate-on-blur>
                <template v-slot:label>Colonia <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <v-col cols="6">
              <BaseInput v-model="referencia.localidad" :rules="nameRules" validate-on-blur>
                <template v-slot:label>Localidad <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <v-col cols="6">
              <BaseInput v-model="referencia.calle" :rules="nameRules" validate-on-blur>
                <template v-slot:label>Calle <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <v-col cols="6">
              <BaseInput v-model="referencia.exterior" :rules="nameRules" validate-on-blur>
                <template v-slot:label>No. Exterior <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <v-col cols="6">
              <BaseInput v-model="referencia.interior" :rules="nameRules" validate-on-blur>
                <template v-slot:label>No. Interior <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <v-col cols="6">
              <BaseInput v-model="referencia.entrecalles" :rules="nameRules" validate-on-blur>
                <template v-slot:label>Entre calles <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <v-col cols="6">
              <BaseInput v-model="referencia.entrecalles2" :rules="nameRules" validate-on-blur>
                <template v-slot:label>Entre calles 2 <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <v-col cols="12">
              <BaseInput v-model="referencia.referencias" :rules="nameRules" validate-on-blur>
                <template v-slot:label>Referencias <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions class="justify-center">
      <TextButton
        color="secondary"
        class="px-8"
        :disabled="!referenciaForm || loading"
        :loading="loading"
        v-on:click="triggerSaveReferencia()"
        >Guardar</TextButton
      >
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import BaseInput from '@/components/base/BaseInput.vue'
import BaseSelect from '@/components/base/BaseSelect.vue'
import TextButton from '../../../base/TextButton.vue'
import ReferenciaEntity from '@/modules/referencias/domain/ReferenciaEntity'
import { TIPO_REFERENCIAS } from '@/modules/referencias/domain/TIPO_REFERENCIAS'

export default {
  components: {
    BaseInput,
    BaseSelect,
    TextButton,
  },

  props: {
    idPersonal: {
      type: Number,
    },

    referenciaToUpdate: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      referenciaForm: false,
      loading: false,
      maskedPhone: '',
      referencia: new ReferenciaEntity(TIPO_REFERENCIAS.VECINAL),
      selectedEstado: null,
      nameRules: [(v) => !!v || 'Este campo es requerido'],
    }
  },

  mounted() {
    if (this.referenciaToUpdate) {
      this.referencia = { ...this.referenciaToUpdate }
      this.maskedPhone = this.referencia.telefono.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, '$1-$2-$3-$4')
      this.selectedEstado = this.estados.find(
        (estado) =>
          estado.id ===
          this.municipios.find((municipio) => municipio.id === this.referencia.fk_idmunicipio)?.fk_idEstado
      )?.id
    }
  },

  computed: {
    ...mapGetters('municipio', {
      municipios: 'getMunicipios',
    }),
    ...mapGetters('estado', {
      estados: 'getEstados',
    }),

    municipiosOptions() {
      return this.municipios
        .filter((municipio) => municipio.fk_idEstado === this.selectedEstado)
        .map((municipio) => ({ id: municipio.id, title: municipio.nombre }))
    },
  },

  methods: {
    ...mapActions('dialog', ['closeDialog']),
    ...mapActions('municipio', ['fetchMunicipios']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapActions('referenciaEnlaceC3', ['createReferencia', 'updateReferencia', 'fetchReferenciasByPersonal']),

    async triggerSaveReferencia() {
      try {
        this.loading = true
        this.referencia.telefono = this.maskedPhone.replace(/-/g, '')

        if (this.referenciaToUpdate) {
          await this.updateReferencia({ idPersonal: this.idPersonal, referencia: this.referencia })
        } else {
          await this.createReferencia({ idPersonal: this.idPersonal, referencia: this.referencia })
        }

        this.resetForm()
        this.closeDialog()
      } catch {
        this.SET_SNACKBAR_MESSAGE('Ocurrió un error al registrar la referencia.')
      } finally {
        this.loading = false
      }
    },

    resetForm() {
      this.referencia = new ReferenciaEntity(TIPO_REFERENCIAS.VECINAL)
      this.maskedPhone = ''
      if (this.$refs.form) this.$refs.form.resetValidation()
    },
  },
}
</script>

<style scoped>
::v-deep .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  box-shadow: none !important;
  transition: all 0.3s ease !important;
}

::v-deep .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.45) !important;
}

::v-deep .v-input--is-focused .v-input__slot {
  border-color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
  background: rgba(16, 16, 30, 0.5) !important;
}

::v-deep .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep input {
  color: #e0e0e0 !important;
  caret-color: var(--v-secondary-base) !important;
}

::v-deep input::placeholder {
  color: rgba(224, 224, 224, 0.5) !important;
}

::v-deep .v-label,
::v-deep .v-input .v-icon {
  color: rgba(var(--v-secondary-base-rgb), 0.75) !important;
}

::v-deep .v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb), 0.6) !important;
}

::v-deep .v-btn .v-icon {
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover .v-icon {
  transform: scale(1.2);
}
</style>
